export default __webpack_public_path__ + "static/news1-27174e8ccd1af1747d260c919f24a942.jpg";